"use strict";

exports.__esModule = true;
exports.bmi = bmi;

function bmi(weightKg, heightCm) {
  var heightM = heightCm * 0.01;
  return Math.round(weightKg / (heightM * heightM));
}